import type { HiddenField } from '@/components/gateway-forms/types';

type SelectOption = {
  key: string;
  value: string;
};
import type { SelectInputProps } from '@/components/select/types';
import type { RadioInputProps } from '@/components/radio-group/types';
import type { CheckboxGroupInputProps } from '@/components/checkbox-group/types';
import type { InputProps } from '@/components/input/types';
import type { TerminFormValues } from './consts';

export type TerminProps = {
  hiddenFields?: HiddenField[];
  bgSectionColor?: string;
  selectValues?: SelectOption[];
  spacingTop?: boolean;
  spacingBottom?: boolean;
  select?: SelectInputProps[];
  radioGroup?: RadioInputProps[];
  checkboxGroup?: CheckboxGroupInputProps[];
  textInputs?: InputProps[];
  sectionId?: string;
  embeddedInMultistep?: boolean;
  multistepConsultationTitle: string;
  multistepTopics: string[];
  multistepAnliegen: string;
  onSubmitRef?: (submit: () => void) => void;
  onBeforeSubmit?: (values: TerminFormValues) => void | Promise<void>;
  onSuccess?: () => void;
  onSubmitStart?: () => void;
  onError?: () => void;
  presetCallbackRequestNotes?: string;
  presetWebsiteSelectedTopics?: string;
};

export const GENDER = {
  MALE: 'Male',
  FEMALE: 'Female',
} as const;

export type Gender = (typeof GENDER)[keyof typeof GENDER];

export const SALUTATION = {
  HERR: 'Herr',
  FRAU: 'Frau',
} as const;

export type Salutation = (typeof SALUTATION)[keyof typeof SALUTATION];
